import { render, staticRenderFns } from "./NewDarkwebLicenseForm.vue?vue&type=template&id=812bd0b2&scoped=true"
import script from "./NewDarkwebLicenseForm.vue?vue&type=script&lang=js"
export * from "./NewDarkwebLicenseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812bd0b2",
  null
  
)

export default component.exports